<template>
  <header>
    <h1>{{ pageTitle }}</h1>
  </header>
</template>


<script>
export default {
  name: 'Header',
  computed: {
    pageTitle() {
      // Get the page title from the current route
      return this.$route.meta.title || 'My Website'
    }
  },
  mounted() {
    // Update the meta tags based on the page title
    const meta = document.createElement('meta')
    meta.setAttribute('name', 'description')
    meta.setAttribute('content', `Welcome to my website! This is the ${this.pageTitle} page.`)
    document.head.appendChild(meta)

    document.title = this.pageTitle
  },
  beforeDestroy() {
    // Remove the meta tags when the component is destroyed
    const meta = document.querySelector('meta[name="description"]')
    if (meta) {
      meta.remove()
    }
  }
}
</script>

<style>
/* Add your custom styles here */
</style>